/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan } from './get-trustdock-verifications200-response-supplemental-document-records-inner-plan';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner } from './get-trustdock-verifications200-response-supplemental-document-records-inner-reasons-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResult } from './get-trustdock-verifications200-response-supplemental-document-records-inner-result';

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
 */
export interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'state': GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResult}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'result': GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'verifiedBy': Array<string> | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'plan': GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan | null;
    /**
     * 
     * @type {object}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'document': object | null;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner>}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'reasons': Array<GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner> | null;
}

export const GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum = typeof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum[keyof typeof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum];


